import React from "react";
import logTypes from "./logTypes";
import convert from "./convert";

const Log = ({ gradedQuestions, log }) => {
    const logType = log.t;

    const backgroundColorLog = () => {
        if (logType === logTypes.SUMMARY) {
            return "var(--accent-one)"
        } else if (logType === logTypes.PROGRAMMING) {
            return "var(--correct)"
        } else if (logType === logTypes.LAMBDA) {
            return "var(--incorrect)"
        }
    }

    const titleLog = () => {
        if (logType === logTypes.SUMMARY) {
            return "Session Activity"
        } else if (logType === logTypes.PROGRAMMING) {
            return "Programming Results"
        } else if (logType === logTypes.LAMBDA) {
            return "Lambda Results"
        }
    }

    const retContent = () => {
        if (logType === logTypes.SUMMARY) {
            return (
                <>
                    <div className="summary-container">
                        <div className="summary-item">
                            Focus Changes: {log.f}
                        </div>
                        <div className="summary-item">
                            Characters Typed: {log.c}
                        </div>
                        <div className="summary-item">
                            Backspaces: {log.b}
                        </div>
                        <div className="summary-item">
                            Paste Events: {log.p}
                        </div>
                        <div className="summary-item">
                            Cursor Moves: {log.x}
                        </div>
                        <div className="summary-item">
                            Mouse Clicks: {log.m}
                        </div>
                        <div className="summary-item">
                            Keystrokes: {log.k}
                        </div>
                    </div>   
                </>
            )
        } else if (logType === logTypes.PROGRAMMING) {
            return (
                <>
                    {
                        log.r === '' ?

                        "Non-zero setup.sh exit code (ex. compiler error) or invalid JSON output"

                        :

                        <div className="failed-id-container">
                            {
                                log.r.length > 0 ?

                                <>
                                    Failed Test IDs: 
                                    {
                                        log.r.map((id) => {return <span className="container-govaluate id-pad">{id}</span>})
                                    }
                                </>

                                :

                                "All tests passed"
                            }
                        </div>                        
                    }
                </>
            )
        } else if (logType === logTypes.LAMBDA) {
            return (
                <>
                    {
                        log.r === '' ?

                        "Non-zero lambda exit code (ex. compiler error)"

                        :

                        <div className="failed-id-container">
                            {
                                log.r.length > 0 ?

                                <>
                                    Failed Test IDs: 
                                    {
                                        log.r.map((id) => {return <span className="container-govaluate id-pad">{id}</span>})
                                    }
                                </>

                                :

                                "All tests passed"
                            }
                        </div>                        
                    }
                </>
            )
        }
    }

    return (
        <>
            <div className="log-container">
                <div className="top-log">
                    <span>
                        {titleLog()}
                        {logType === logTypes.LAMBDA ? ` (${(() => {
                            const index = gradedQuestions?.findIndex(q => q.uuid === log.u);

                            return index === -1 ? "N/A" : ('Q' + (index + 1))
                        })()})` : ""}
                    </span>
                    <span style={{ textAlign: "right" }}>
                        {
                            logType === logTypes.SUMMARY ? (convert(log.s) + " to " + convert(log.e, true)) : convert(log.e, true)
                        }
                    </span>
                </div>
                <div className="middle-log">
                    {retContent()}
                </div>
                <div className="bottom-log" style={{ backgroundColor: backgroundColorLog() }}/>
            </div>
        </>
    );
}

export default Log;